import styles from './FilterSegment.module.css'
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import { useState } from 'react'
import CustomButton from '../UI/CustomButton/CustomButton'
import CustomRadio from '../UI/CustomRadio/CustomRadio'
import exitIcon from '../../assets/icons/close.svg'

interface Props {
  onClickHandler: () => void
  dateBlock: JSX.Element
  segments?: string[]
  revenue?: string[]
  setActiveFilterButton?: React.Dispatch<React.SetStateAction<string>>
  setActiveRevenue?: (selected: any) => void
  resetFilters?: JSX.Element
}

const FilterSegment: React.FC<Props> = ({
  onClickHandler,
  dateBlock,
  segments,
  setActiveFilterButton,
  revenue,
  setActiveRevenue,
  resetFilters,
}) => {
  const [selected, setSelected] = useState<string>('')

  return (
    <div className={styles.filterContainer}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h3>Фильтры</h3>
          <div className={styles.iconContainer} onClick={onClickHandler}>
            <img className={styles.exitIcon} src={exitIcon} alt='exitIcon' />
          </div>
        </div>
        <div className={styles.content}>
          {revenue && setActiveRevenue && revenue?.length >= 1 ? (
            <div className={styles.radioWrapper}>
              <h3>Выручка</h3>
              <CustomRadio
                column={true}
                options={revenue}
                name='role'
                value={selected}
                onChange={(e) => {
                  setSelected(e.target.value)
                  setActiveRevenue(e.target.value)
                }}
              />
            </div>
          ) : (
            <div className={styles.radioWrapper}>
              <h3>Сегмент</h3>
              <CustomRadio
                column={true}
                options={segments}
                name='role'
                value={selected}
                onChange={(e) => {
                  if (setActiveFilterButton) {
                    setSelected(e.target.value)
                    setActiveFilterButton(e.target.value)
                  }
                }}
              />
            </div>
          )}
          {dateBlock}
          {resetFilters}
        </div>
      </div>
      <div className={styles.footerContainer}>
        <CustomButton
          title='Применить'
          className={styles.filtersBtn}
          type='button'
          onClick={() => {
            onClickHandler()
          }}
        />
      </div>
    </div>
  )
}

export default FilterSegment
